@if (history$ | async; as history) {
  @if (history.length > 0) {
    <div>
      <div [ngClass]="_noCard ? 'px-6' : 'overflow-hidden rounded-lg bg-surface shadow py-4 px-6'">
        <ul role="list" class="-mb-8">
          @for (historyElement of history; track historyElement; let last = $last) {
            <li>
              <div class="relative pb-8">
                @if (!last) {
                  <span
                    class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-edge"
                    aria-hidden="true"
                  ></span>
                }
                <div class="relative flex space-x-3 items-center">
                  <span
                    class="h-8 w-8 rounded-full bg-fg-faint flex items-center justify-center ring-8 ring-surface"
                    [class.!bg-blue-400]="loggedInUserId === historyElement.userId"
                  >
                    <span class="text-sm font-medium leading-none text-white uppercase">{{
                      historyElement.userInitials
                    }}</span>
                  </span>
                  <div class="text-sm flex min-w-0 flex-1 justify-between">
                    <div>
                      <span class="text-fg-secondary">
                        @switch (historyElement.type) {
                          @case ('create') {
                            <span>Erstellt </span>
                          }
                          @case ('update') {
                            <span>Geändert </span>
                          }
                          @case ('delete') {
                            <span>Gelöscht </span>
                          }
                        }
                        <span>durch </span>
                      </span>
                      <span class="font-medium text-fg-primary"> {{ historyElement.user }}</span>
                    </div>
                    <div class="whitespace-nowrap text-right text-sm text-fg-secondary">
                      <time>{{ historyElement.timestamp | date: 'dd.MM.yyy HH:mm:ss' }} </time>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  }
}
